import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../data/mockData";
import { ArrowRight } from "lucide-react";

const AboutPreview = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Full-width header above photo */}
        <div className="max-w-4xl mb-14">
          <span className="text-sm font-semibold text-[#3A7D44] uppercase tracking-wider">
            Meet Your Broker
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1B2A1B] mt-4 mb-5 leading-tight"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            I've Been Where You Are
          </h2>
          <p className="italic text-[#5A6B5A] text-base">
            That's not a tagline. It's why I do this work differently.
          </p>
        </div>

        {/* Two-column: photo left, body right */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={siteConfig.kimAboutPreviewPhoto}
                alt="Kimberly Hess"
                className="w-full object-cover rounded-2xl aspect-[3/4] max-w-md"
              />
            </div>
            <div className="absolute -z-10 -bottom-6 -right-6 w-full h-full bg-[#E8F5E9] rounded-2xl" />
          </div>

          {/* Body copy */}
          <div>
            <div className="space-y-5 text-[#5A6B5A] leading-relaxed mb-8">
              <p>
                Before I became a licensed health insurance broker, I was
                self-employed and trying to navigate health insurance on my own.
                I remember feeling overwhelmed by the options and frustrated by
                how difficult it was to get straightforward answers.
              </p>
              <p>
                That experience is why I built my practice around independent
                professionals and small business owners. You deserve someone who
                will give you straight answers, explain your options clearly,
                and still be there after you enroll.
              </p>
              <p>
                I'm licensed in all 50 states and work with multiple carriers.
                That means I can shop several insurance companies on your behalf
                instead of offering just one company's plans.
              </p>
              <p>
                When something changes — a health event, a life change, a carrier
                update — I'm here year-round. Not just at open enrollment.
              </p>
            </div>

            <p className="text-sm font-semibold text-[#3A7D44] mb-8">
              Licensed Health Insurance Broker · All 50 States · Independent
              <span className="font-normal text-[#5A6B5A]"> — not tied to any single carrier</span>
            </p>

            <Link
              to="/about"
              data-testid="about-preview-learn-more"
              className="inline-flex items-center gap-2 text-[#3A7D44] font-semibold hover:gap-3 transition-all duration-200"
            >
              Learn more about Kimberly
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
